import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'nm-widget-box',
	templateUrl: './widget.html'
})
export class NmWideget {}


@Component({
	selector: 'nm-widget-header',
	templateUrl: './widget-header.html'
})
export class NmWidgetHeader {}


@Component({
	selector: 'nm-widget-body',
	templateUrl: './widget-body.html'
})
export class NmWidgetBody {}


@Component({
	selector: 'nm-widget-tools',
	templateUrl: './widget-tools.html'
})
export class NmWidgetTools {
	@Input() actions: string[];
	@Output() onSelect = new EventEmitter<string>();

	public ngAfterViewInit() {
		this.current = this.actions[0];
	}

	public current: string;

	public onClick(action: string) {
		this.current = action;
		this.onSelect.emit(action);
	}
}


// WEBPACK FOOTER //
// ./src/widgets/widget/widget.ts